import {Button} from '@chekinapp/ui';

import styled from 'styled-components';

export const StyledButton = styled(Button)`
  margin-top: 24px;
`;
